import React from 'react';
import styled from 'styled-components';
import moment, { Moment } from 'moment';
import { TimePicker, DatePicker } from '../../../../react-common/Pickers';

interface NewTourFormProps {
  setTourDate?: (date: Date) => void;
  setTourName?: (name: string) => void;
  setIsError?: (isError: boolean) => void;
  tourDate?: Date;
  tourName?: string;
}

const NewTourForm: React.FC<NewTourFormProps> = ({
  setTourDate,
  tourDate,
  setTourName,
  tourName,
  setIsError,
}) => {
  const pickerHandler = (type: 'date' | 'time', time: Moment) => {
    if (type === 'date') {
      // need to manually set the hour && minute since date picker only changes the date
      const newDateTime = moment(time)
        .set({
          ...(!tourDate && {
            hour: moment().hour(),
            minute: moment().minute(),
          }),
          second: 0,
        })
        .toDate();
      setTourDate(newDateTime);
    } else {
      const hour = moment(time).hours();
      const min = moment(time).minutes();
      const newDateTime = moment(tourDate || new Date())
        .hours(hour)
        .minutes(min)
        .seconds(0)
        .toDate();
      setTourDate(newDateTime);
    }
  };

  return (
    <FlexContainer>
      <Row>
        <Label>Tour Name: </Label>
        <StyledInput
          className="form-control"
          type="text"
          value={tourName}
          onChange={e => setTourName(e.target.value)}
          data-cy="vtform-name"
        />
      </Row>
      <Row>
        <Label>Date: </Label>
        <StyledDatePicker
          PopoverProps={{ disableEnforceFocus: true }}
          inputVariant="outlined"
          value={tourDate}
          format="YYYY-MM-DD"
          variant="inline"
          autoOk
          disablePast
          minDateMessage="Virtual tour date should not be in the past"
          onChange={(val: Moment) => pickerHandler('date', val)}
          onError={error => setIsError(!!error)}
          data-cy="create-new-date"
        />
      </Row>
      <Row>
        <Label>Time: </Label>
        <StyledTimePicker
          PopoverProps={{ disableEnforceFocus: true }}
          value={tourDate}
          inputVariant="outlined"
          mask="__:__ _M"
          variant="inline"
          autoOk
          onChange={(val: Moment) => pickerHandler('time', val)}
          data-cy="create-new-time"
        />
      </Row>
    </FlexContainer>
  );
};

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  padding-bottom: 10px;
  width: 90%;
  margin: auto;
`;

const Label = styled.div`
  padding-right: 20px;
  text-align: right;
  width: 30%;
  white-space: nowrap;
`;

const StyledDatePicker = styled(DatePicker)`
  width: 70%;
  max-width: 250px;
`;
const StyledTimePicker = styled(TimePicker)`
  width: 70%;
  max-width: 250px;
`;

const StyledInput = styled.input`
  font-size: 14px;
  line-height: 20px;
  padding: 7px 12px;
  height: 34px;
  width: 70%;
  max-width: 250px;
  border-radius: 4px;
  border: 1px solid #ccc;
  &:hover {
    border: 1px solid black;
  }
`;

export default NewTourForm;
